<template>
  <div class="app">
    <!-- 시네마틱 스플래시 화면 (PC만) -->
    <div v-if="!isMobile" class="splash-overlay" :class="{ hide: introComplete }">
      <!-- 3분할 패널 -->
      <div class="split-panel panel-left" :class="{ 'slide-up': splitReveal }"></div>
      <div class="split-panel panel-center" :class="{ 'slide-up': splitReveal }"></div>
      <div class="split-panel panel-right" :class="{ 'slide-up': splitReveal }"></div>

      <!-- 스플래시 콘텐츠 -->
      <div class="splash-content" :class="{ show: contentShow, 'fade-out': splitReveal }">
        <p class="splash-sub">구미 그 위에 펼쳐지는 또 다른 세상</p>
        <h2 class="splash-main">"단지"가 아닌"도시" 압도적 클래스</h2>
        <div class="splash-divider"></div>
        <div class="splash-logo">
          <img src="@/assets/logo/logo2.png" alt="HEMATEN" />
        </div>
      </div>
    </div>

    <!-- 메인 콘텐츠 -->
    <div class="site-wrapper" :class="{ show: isMobile || introComplete }">
      <AppHeader />

      <!-- 모바일 프로모션 바 (헤더 아래 고정) -->
      <MobilePromoBar v-if="isMobile" @open-form="openReservationForm" />

      <main class="main-content" :class="{ 'mobile': isMobile }">
        <router-view :is-mobile="isMobile" @open-form="openReservationForm" />
      </main>
      
      <AppFooter />
      
      <!-- PC: 기존 플로팅 (홈에서만) -->
      <FloatingContact v-if="!isMobile && $route.path === '/'" ref="floatingContact" />
      
      <!-- 모바일: 플로팅 버튼 + 하단 배너 -->
      <template v-if="isMobile">
        <MobileFloating @open-form="openReservationForm" />
        <MobileBottomBanner @open-form="openReservationForm" />
      </template>

      <!-- 모바일: 방문예약 모달 -->
      <MobileReservationModal
        v-if="isMobile"
        :is-open="isReservationOpen"
        @close="closeReservationForm"
      />

      <!-- 메인 팝업 (첫 진입시) -->
      <MainPopup @open-form="openReservationForm" />

      <!-- 관심고객등록 팝업 (첫 진입시) -->
      <RegistrationPopup />
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'
import FloatingContact from '@/components/common/FloatingContact.vue'

// 모바일 컴포넌트
import MobilePromoBar from '@/components/mobile/MobilePromoBar.vue'
import MobileFloating from '@/components/mobile/MobileFloating.vue'
import MobileBottomBanner from '@/components/mobile/MobileBottomBanner.vue'
import MobileReservationModal from '@/components/mobile/MobileReservationModal.vue'
import MainPopup from '@/components/common/MainPopup.vue'
import RegistrationPopup from '@/components/common/RegistrationPopup.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    FloatingContact,
    MobilePromoBar,
    MobileFloating,
    MobileBottomBanner,
    MobileReservationModal,
    MainPopup,
    RegistrationPopup
  },
  data() {
    return {
      // 디바이스 체크
      isMobile: false,
      breakpoint: 768,
      // 시네마틱 스플래시
      contentShow: false,
      splitReveal: false,
      introComplete: false,
      // 방문예약 모달
      isReservationOpen: false
    }
  },
  mounted() {
    // 디바이스 체크
    this.checkDevice()
    window.addEventListener('resize', this.checkDevice)

    // 스플래시 애니메이션 (PC만)
    if (!this.isMobile) {
      this.startSplash()
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkDevice)
  },
  methods: {
    checkDevice() {
      this.isMobile = window.innerWidth <= this.breakpoint
    },
    startSplash() {
      // 콘텐츠 페이드 인
      setTimeout(() => { this.contentShow = true }, 300)

      // 3분할 위로 올라가면서 사라짐
      setTimeout(() => { this.splitReveal = true }, 2500)

      // 스플래시 완전히 숨김
      setTimeout(() => { this.introComplete = true }, 4200)
    },
    openReservationForm() {
      if (this.isMobile) {
        this.isReservationOpen = true
      } else {
        // PC: FloatingContact의 폼 열기
        if (this.$refs.floatingContact) {
          this.$refs.floatingContact.toggleForm()
        }
      }
    },
    closeReservationForm() {
      this.isReservationOpen = false
    }
  }
}
</script>

<style>
@import url('https://cdn.jsdelivr.net/gh/wanteddev/wanted-sans/packages/wanted-sans/fonts/webfonts/variable/split/WantedSansVariable.min.css');
@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable.min.css');

:root {
  --main-color1: #A67C52;
  --main-color2: #8B5A2B;
  --gold-light: #D4AF37;
  --gold-dark: #996515;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 스크롤바 숨기기 */
html {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE, Edge */
}

html::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

body {
  font-family: 'Wanted Sans Variable', 'Wanted Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow-x: hidden;
}

a {
  text-decoration: none;
  color: inherit;
}

.main-content {
  padding-top: 80px;
}

.main-content.mobile {
  padding-top: 100px;
  padding-bottom: 70px;
}

@media (max-width: 1024px) {
  .main-content {
    padding-top: 60px;
  }
}

/* ========== 시네마틱 스플래시 ========== */
@import url('https://fonts.googleapis.com/css2?family=Noto+Serif+KR:wght@200;300;400;500;600;700;900&display=swap');

.splash-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 9999;
  overflow: hidden;
}

.splash-overlay.hide {
  visibility: hidden;
  pointer-events: none;
}

/* 3분할 패널 */
.split-panel {
  position: absolute;
  top: 0;
  width: 33.34%;
  height: 100%;
  background: #3d3428;
  z-index: 2;
  transition: transform 1.5s cubic-bezier(0.76, 0, 0.24, 1);
}

.panel-left {
  left: 0;
}

.panel-center {
  left: 33.33%;
  transition-delay: 0.1s;
}

.panel-right {
  left: 66.66%;
  transition-delay: 0.2s;
}

.split-panel.slide-up {
  transform: translateY(-100%);
}

/* 스플래시 콘텐츠 */
.splash-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  text-align: center;
  opacity: 0;
  transition: opacity 1s ease;
}

.splash-content.show {
  opacity: 1;
}

.splash-content.fade-out {
  opacity: 0;
  transition: opacity 0.8s ease;
}

.splash-sub {
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 20px;
}

.splash-main {
  font-family: 'Noto Serif KR', serif;
  font-size: 32px;
  font-weight: 500;
  color: #fff;
  letter-spacing: 3px;
  margin: 0 0 40px 0;
}

.splash-divider {
  width: 1px;
  height: 50px;
  background: rgba(255, 255, 255, 0.3);
  margin: 0 auto 30px;
}

.splash-logo {
  display: flex;
  justify-content: center;
  align-items: center;
}

.splash-logo img {
  height: 60px;
  width: auto;
}

/* 반응형 */
@media (max-width: 1024px) {
  .splash-sub {
    font-size: 13px;
  }
  .splash-main {
    font-size: 26px;
  }
  .splash-logo img {
    height: 50px;
  }
}

@media (max-width: 768px) {
  .splash-sub {
    font-size: 12px;
    letter-spacing: 1px;
  }
  .splash-main {
    font-size: 22px;
    letter-spacing: 2px;
  }
  .splash-logo img {
    height: 45px;
  }
}


/* 메인 콘텐츠 */
.site-wrapper {
  opacity: 0;
  transition: opacity 0.8s ease;
}

.site-wrapper.show {
  opacity: 1;
}

</style>